import styled from 'styled-components';
import withColor from 'util/hoc/with-color';
import { resolve } from 'library/helpers/path-resolver';

const Body = styled.div`
  height: ${(props) => resolve(props, 'height', '128px')};
  width: ${(props) => resolve(props, 'width', '418px')};
  border-radius: 0.25em;
  background-color: #ffffff;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1), 1px 3px 6px 0 rgba(0, 0, 0, 0.22);
  padding: 1em;
  border-top: ${(props) =>
    props.borderColor && `5px solid ${props.borderColor}`};
`;

const Title = withColor(styled.h2`
  margin: 0;
  padding: 0;
  height: ${(props) => resolve(props, 'height', '26px')};
  width: ${(props) => resolve(props, 'width', '272.87px')};
  color: ${(props) => resolve(props, 'colors/grey1', '#595959')};
  font-family: Lato;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.05px;
  line-height: 26px;
`);

export { Body, Title };
